import { render } from "./FindObservatory.vue?vue&type=template&id=30cd9344"
import script from "./FindObservatory.vue?vue&type=script&lang=js"
export * from "./FindObservatory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__